module.exports = __webpack_public_path__ + "static/media/formula_mobile.1d925bed.png";